import { useTranslation } from "react-i18next";

import { MTablePagination } from "material-table";

import {
	FirstPage,
	LastPage,
	SkipNext,
	SkipPrevious,
} from "../../utils/barrels/material-ui-icons";

import {
	PageNumberDisplay,
	PaginationWrapper,
	StyledMTablePagination,
} from "./index.styles";

const SafeMTablePagination = ({
	classes: styleClasses = {},
	currentPageNo,
	labelPrefix,
	...propsNew
}) => {
	const { t } = useTranslation();
	const mtableClasses = propsNew.classes || {};
	const rootClassName = [
		mtableClasses.root || "",
		styleClasses?.mTableFooterRoot || "",
	]
		.join(" ")
		.trim();

	let computedPage = "";
	if (currentPageNo !== undefined && currentPageNo !== null) {
		computedPage = currentPageNo;
	} else if (typeof propsNew.page === "number") {
		computedPage = propsNew.page + 1;
	}

	const prefix = labelPrefix || (typeof t === "function" ? t("page") : "Page");

	const paginationIcons = {
		FirstPage,
		LastPage,
		PreviousPage: SkipPrevious,
		NextPage: SkipNext,
	};

	const { icons: providedIcons, ...restProps } = propsNew;

	if (providedIcons && typeof providedIcons === "object") {
		if (providedIcons.FirstPage) {
			paginationIcons.FirstPage = providedIcons.FirstPage;
		}
		if (providedIcons.LastPage) {
			paginationIcons.LastPage = providedIcons.LastPage;
		}
		if (providedIcons.PreviousPage) {
			paginationIcons.PreviousPage = providedIcons.PreviousPage;
		}
		if (providedIcons.NextPage) {
			paginationIcons.NextPage = providedIcons.NextPage;
		}
	}

	const isCountDash = restProps.count === "-" || restProps.count === "";
	let validCount = 0;
	if (isCountDash) {
		validCount = Number.MAX_SAFE_INTEGER;
	} else if (typeof restProps.count === "number" && !isNaN(restProps.count)) {
		validCount = Math.max(0, restProps.count);
	} else if (typeof restProps.count === "string") {
		const parsed = parseInt(restProps.count, 10);
		if (!isNaN(parsed) && parsed >= 0) {
			validCount = parsed;
		}
	}

	const validRowsPerPage =
		typeof restProps.rowsPerPage === "number" &&
		!isNaN(restProps.rowsPerPage) &&
		restProps.rowsPerPage > 0
			? restProps.rowsPerPage
			: 10;

	const validPage =
		typeof restProps.page === "number" &&
		!isNaN(restProps.page) &&
		restProps.page >= 0
			? restProps.page
			: 0;

	const defaultLocalization = restProps.localization || {};

	const fromValue = validPage * validRowsPerPage + 1;
	const toValue =
		validCount > 0 && validCount < Number.MAX_SAFE_INTEGER
			? Math.min((validPage + 1) * validRowsPerPage, validCount)
			: (validPage + 1) * validRowsPerPage;
	const countValue = isCountDash ? "-" : validCount;

	const customLocalization = isCountDash
		? {
				...defaultLocalization,
				labelDisplayedRows: `${fromValue}-${toValue} of ${countValue}`,
			}
		: {
				...defaultLocalization,
				labelDisplayedRows:
					defaultLocalization.labelDisplayedRows || "{from}-{to} of {count}",
			};

	const finalIcons = {
		FirstPage: paginationIcons.FirstPage || FirstPage,
		LastPage: paginationIcons.LastPage || LastPage,
		PreviousPage: paginationIcons.PreviousPage || SkipPrevious,
		NextPage: paginationIcons.NextPage || SkipNext,
	};

	return (
		<PaginationWrapper>
			<PageNumberDisplay className={styleClasses?.tablePageNum}>
				{prefix}: {computedPage}
			</PageNumberDisplay>
			<StyledMTablePagination className={styleClasses?.mTableFooterRoot}>
				<MTablePagination
					{...restProps}
					count={validCount}
					page={validPage}
					rowsPerPage={validRowsPerPage}
					icons={finalIcons}
					localization={customLocalization}
					classes={{
						...mtableClasses,
						root: rootClassName,
					}}
				/>
			</StyledMTablePagination>
		</PaginationWrapper>
	);
};

export default SafeMTablePagination;
